import { styled } from '@mui/system';
import { Box, Typography, IconButton } from '@mui/material';

// General row layout for grid alignment
export const StyledWeekContainer = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  display: 'flex',
  padding: theme.spacing(1),
  gap: '1rem',
  width: '100%',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '1rem',
  maxHeight: '54px,',
}));

export const StyledWeekPickerWrapper = styled(Box)(() => ({
  position: 'relative',
}));

// Week title styling
export const StyledWeekTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  cursor: 'pointer',
  padding: `0 ${theme.spacing(1)}`,
  lineHeight: '22px',
  letterSpacing: '-0.4px',
  width: '12em',
  display: 'block',
  textAlign: 'center',
  fontWeight: 500, // Slightly bold for emphasis
  '&:hover': {
    color: theme.palette.text.secondaryHover,
  },
}));

// Back icon styling
export const StyledIconBack = styled(IconButton)(({ theme }) => ({
  color: theme.palette.text.secondary,
  height: '28px', // Slightly larger for better touch targets
  width: '28px',
  transition: 'color 0.3s ease, transform 0.2s ease', // Smooth hover effect
  justifySelf: 'start',
  '&:hover': {
    color: theme.palette.text.secondaryHover,
    transform: 'scale(1.1)', // Slight zoom effect on hover
    backGroundColor: theme.palette.background.hover,
  },
}));

// Forward icon styling
export const StyledIconForward = styled(IconButton)(({ theme }) => ({
  color: theme.palette.text.secondary,
  // Use secondary text color
  height: '28px',
  width: '28px',
  transition: 'color 0.3s ease, transform 0.2s ease', // Smooth hover effect
  '&:hover': {
    color: theme.palette.text.secondaryHover,
    transform: 'scale(1.1)', // Slight zoom effect on hover
    backGroundColor: theme.palette.background.hover,
  },
  justifySelf: 'end',
}));

// Container for the floating calendar
export const StyledCalendarContainer = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: '100%', // Position below the title
  left: '48%',
  transform: 'translateX(-45%)', // Center align horizontally
  zIndex: 10,
  backgroundColor: theme.palette.background.secondary, // Ensure it looks like a floating card
  color: 'theme.palette.text.secondary',
  boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)', // Add shadow for floating effect
  borderRadius: '8px',
  padding: 0,
}));
